// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n5-0";
export var fileList = "_n5-2";
export var removeFileButton = "_n5-1";